import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {}

const mutations = {}
const actions = {
    async signIn ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.signin, payload)
            if (resp && resp.data && resp.data.displayMsg && resp.data.displayMsg.e) {
                Toastr.error(resp.data.displayMsg.e.head, resp.data.displayMsg.e.msg)
            } else {
                if (resp && resp.data && resp.data.token) {
                    localStorage.token = resp.data.token
                    commit('setUser', resp.data.token, { root: true })
                }
            }
            return resp
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
